var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.publicKey)?_c('VueReCaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.publicKey,"load-recaptcha-script":true,"type":"Checkbox","size":"12"},on:{"verify":_vm.validate,"expired":_vm.reset}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }